export default __webpack_public_path__ + "fcd1d60c5ae187d2473634d135ab8c4a.svg";